/**
 * Created by mh on 2017/5/28.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import DatePicker from 'react-datepicker';
import moment from 'moment';

import ChannelModel from './model/ChannelModel';

import { MdRadio, MdTv } from 'react-icons/md';

import 'react-datepicker/dist/react-datepicker.css';

// TODO generalize
const TypeToIcon = (type) => {
    switch (type) {
    case 'radio':
        return <MdRadio />;
    case 'tv':
        return <MdTv />;
    default:
        return type;
    }
};

const TypeToColorClass = (type) => {
    switch (type) {
    case 'radio':
        return 'badge-primary';
    case 'tv':
        return 'badge-success';
    default:
        return 'badge-secondary';
    }
};

const BuildExportPath = (channelId, template, from, to, token) =>
    `/api/channels/${channelId}/timelines/export/template/${template}?from=${from}&to=${to}&download=true${token ? `&access_token=${token}` : ''}`;


const TypeBadge = type => <span className={`badge ${TypeToColorClass(type)}`}>{TypeToIcon(type)} {type}</span>;

@inject('auth') @observer
export default class ChannelTableRow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate: moment().startOf('month'),
            endDate: moment().startOf('month').add(1, 'M'),
        };
        // this.handleStartChange = this.handleChange.bind(this);
    }

    handleStartChange = (date) => {
        this.setState({
            startDate: date,
            // endDate: moment(date).add(1, 'M'),
        });
    }
    handleEndChange = (date) => {
        this.setState({
            endDate: date,
        });
    }

    render() {
        const { auth, channel } = this.props;
        return (
            <tr>
                <td className="align-middle">
                    {TypeBadge(channel.type)}
                </td>
                <td className="align-middle">
                    <Link className="" to={`/channels/details/${channel.id}/`}>
                        <strong>{channel.name}</strong>
                    </Link>
                </td>
                <td className="align-middle">
                    <form className="form-inline">
                        <Link className="btn btn-sm btn-secondary mr-sm-2" to={`/channels/details/${channel.id}/`}>+</Link>
                        <DatePicker
                            selected={this.state.startDate}
                            selectsStart
                            startDate={this.state.startDate}
                            endDate={this.state.endDate}
                            onChange={this.handleStartChange}
                            dateFormat="YYYY-MM-DD"
                            dateFormatCalendar="MMM YYYY"
                            minDate={moment(this.state.startDate).subtract(6, 'month')}
                            maxDate={moment(this.state.startDate).add(6, 'month')}
                            showMonthYearDropdown
                            className="form-control mb-2 mr-sm-2 mb-sm-0"
                        />
                        <DatePicker
                            selected={this.state.endDate}
                            selectsEnd
                            startDate={this.state.startDate}
                            endDate={this.state.endDate}
                            onChange={this.handleEndChange}
                            dateFormat="YYYY-MM-DD"
                            dateFormatCalendar="MMM YYYY"
                            minDate={moment(this.state.endDate).subtract(6, 'month')}
                            maxDate={moment(this.state.endDate).add(6, 'month')}
                            showMonthYearDropdown
                            className="form-control mb-2 mr-sm-2 mb-sm-0"
                        />
                        <Link
                            className="btn btn-sm btn-secondary ml-1"
                            target="_blank"
                            to={BuildExportPath(channel.id, 'suisa.csv', this.state.startDate.format('YYYY-MM-DD'), this.state.endDate.format('YYYY-MM-DD'), auth.token)}>
                            <strong>SUISA Report</strong>
                        </Link>
                        <Link
                            className="btn btn-sm btn-secondary ml-1"
                            target="_blank"
                            to={BuildExportPath(channel.id, 'wideorbit.csv', this.state.startDate.format('YYYY-MM-DD'), this.state.endDate.format('YYYY-MM-DD'), auth.token)}>
                            <strong>WideOrbit Report</strong>
                        </Link>

                    </form>
                </td>
            </tr>);
    }
}
ChannelTableRow.propTypes = {
    auth: PropTypes.object.isRequired,
    channel: PropTypes.instanceOf(ChannelModel).isRequired,
};
